import { memo } from "react";

import cc from "classcat";

import styles from "./MenuItem.module.scss";

interface SidebarStandardItemProps {
  title: React.ReactNode;
  route: string;
  icon?: string;
  newTab?: boolean;
  isActive: boolean;
  isVisible?: boolean;
  hideIcon?: boolean;
}

const SidebarStandardItem = memo(function SidebarStandardItem({
  title,
  route,
  icon,
  newTab,
  isActive,
  isVisible,
  hideIcon = false,
}: SidebarStandardItemProps) {
  const itemClass = cc([
    styles["icon-title-container"],
    styles["menu-item-text"],
    !isActive && styles.hover,
    isActive && styles["sub-item-active"],
  ]);

  return (
    <button
      className={itemClass}
      title={typeof title === "string" ? title : undefined}
      onClick={() => {
        const target = newTab ? "_blank" : "_self";
        window.open(route, target);
      }}
      role="menuitem"
      tabIndex={isVisible ? 0 : -1}
    >
      {icon && !hideIcon && (
        <div className={`narmi-icon-${icon}`} aria-hidden="true" />
      )}
      <span>{title}</span>
    </button>
  );
});

export default SidebarStandardItem;
